const forceRefreshPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("cache_reset_date", new Date().getTime().toString());
    window.location.replace(`${window.location.pathname}?${searchParams}`);
};
export default forceRefreshPage;
//# sourceMappingURL=forceRefreshPage.js.map